<template>
    <div>
        <b-button id="openUserSelection" variant="secondary"
            >{{ $t('userSelection.action') }}
        </b-button>
        <b-popover
            target="openUserSelection"
            triggers="click"
            placement="rightbottom"
            ref="popover"
        >
            <template #title>
                <!-- Close icon -->
                <icon-close
                    id="label-popover-close'"
                    @close="$_onClose"
                    iconColor=""
                >
                </icon-close>
                <span>{{ $t('userSelection.title') }}</span>
            </template>
            <div>
                <b-card style="max-width: 30rem" class="mb-2">
                    <b-card-title>{{
                        $t('userSelection.deleteUsers')
                    }}</b-card-title>
                    <b-button
                        id="deleteUsers"
                        variant="primary"
                        size="sm"
                        @click="$_deleteUsers()"
                    >
                        <span
                            class="fas"
                            v-bind:class="{
                                'fa-check': !isAdding,
                                'fa-sync-alt fa-spin': isAdding
                            }"
                        >
                        </span
                        >&nbsp;{{ $t('userSelection.delete') }}
                    </b-button>
                    <b-card-text class="mt-1" v-if="currentUserSelected">{{
                        $t('userSelection.noDeleteCurrentUser')
                    }}</b-card-text>
                </b-card>
                <b-card style="max-width: 30rem">
                    <b-card-title>{{
                        $t('userSelection.assignGroup')
                    }}</b-card-title>
                    <b-card-text>
                        <x-select
                            id="userGroup"
                            name="userGroup"
                            :options="userGroupOptions"
                            v-model="selectedUserGroup"
                            :simpleMode="true"
                            size="sm"
                        >
                        </x-select>
                    </b-card-text>
                    <b-button
                        id="addUsersToGroup"
                        variant="primary"
                        size="sm"
                        @click="$_addUsersToGroup()"
                        :disabled="isAdding || !groupSelected"
                    >
                        <span
                            class="fas"
                            v-bind:class="{
                                'fa-check': !isAdding,
                                'fa-sync-alt fa-spin': isAdding
                            }"
                        >
                        </span
                        >&nbsp;{{ $t('userSelection.labelAdd') }}
                    </b-button>
                </b-card>
            </div>
        </b-popover>
    </div>
</template>

<script>
    import IconClose from '../../components/IconClose.vue';
    import XSelect from '../../components/BaseComponents/x-select.vue';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import { convertToValueTextPair } from '../../services/utilities';
    export default {
        mixins: [modalMixin],
        components: {
            'icon-close': IconClose,
            'x-select': XSelect
        },
        props: { selectedUsers: [], userGroups: [] },
        data() {
            return {
                selectedUserGroup: null,
                isAdding: false
            };
        },

        computed: {
            currentUserSelected() {
                return this.selectedUsers.some(
                    (s) => s.selected && s.id === this.$store.state.userInfo.userID
                );
            },
            groupSelected() {
                return this.selectedUserGroup != null;
            },
            userGroupOptions() {
                return convertToValueTextPair(this.userGroups, 'id', 'name');
            }
        },
        methods: {
            // close popover
            $_onClose() {
                this.$refs.popover.$emit('close');
            },
            $_deleteUsers() {
                const data = {
                    message: this.$t('userSelection.deleteConfirmation')
                };
                this.msgBoxConfirm(data).then((confirm) => {
                    if (confirm) {
                        this.$_delete();
                    }
                });
            },
            $_delete() {
                this.isAdding = true;

                const userIds = this.selectedUsers
                    .filter((e) => e.selected)
                    .map((e) => e.id);
                this.$store
                    .dispatch('useApiData', {
                        name: 'DeleteUsers',
                        data: userIds
                    })
                    .then(() => {
                        const data = {
                            message: this.$t('userSelection.deletedConfirmation'),
                            variant: 'success',
                            autoHideDelay: 2500,
                            noCloseButton: true
                        };
                        this.showToast(data);
                        this.isAdding = false;
                        this.$refs.popover.$emit('close');
                        this.$emit('reloadUsers');
                    })
                    .catch((error) => {
                        const data = {
                            message: error.message,
                            variant: 'danger',
                            title: this.$t('saveFailureTitle'),
                            autoHideDelay: 10000
                        };
                        this.showToast(data);
                        this.isAdding = false;
                        this.$refs.popover.$emit('close');
                    });
            },
            $_addUsersToGroup() {
                this.isAdding = true;

                const userIds = this.selectedUsers
                    .filter((e) => e.selected)
                    .map((e) => e.id);

                this.$store
                    .dispatch('useApiData', {
                        name: 'AddUsersToUserGroup',
                        parameters: { Id: this.selectedUserGroup },
                        data: userIds
                    })
                    .then(() => {
                        const data = {
                            message: this.$t('userSelection.savedConfirmation'),
                            variant: 'success',
                            autoHideDelay: 2500,
                            noCloseButton: true
                        };
                        this.showToast(data);
                        this.isAdding = false;
                        this.$refs.popover.$emit('close');
                        this.$emit('reloadUsers');
                    })
                    .catch((error) => {
                        const data = {
                            message: error.message,
                            variant: 'danger',
                            title: this.$t('saveFailureTitle'),
                            autoHideDelay: 10000
                        };
                        this.showToast(data);
                        this.isAdding = false;
                        this.$refs.popover.$emit('close');
                    });
            }
        }
    };
</script>

<style scoped lang="scss">
.popover {
    max-width: 500px !important;
    width: 500px !important;
    z-index: 9;
}
</style>

